"use client";

import { ComponentProps } from "react";
import { Checkbox as RadixCheckbox } from "@radix-ui/themes";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "@heroicons/react/20/solid";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";

type Props = {
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
  shopsiteVariant?: "small" | "large";
};

export default function Checkbox({
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  shopsiteVariant = "small",
  ref,
  ...props
}: Props & ComponentProps<typeof RadixCheckbox>) {
  const isShopsite = useIsShopsite();

  const shopsiteBaseClasses = joinClassNames(
    "peer bg-white shrink-0 rounded-sm border border-gray-400 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-indigo-500 data-[state=checked]:border-indigo-500 data-[state=checked]:text-white data-[state=checked]:font-bold hover:border-gray-500 data-[state=checked]:hover:bg-indigo-600",
    shopsiteVariant === "large" ? "h-4 w-4" : "h-[13px] w-[13px]"
  );

  return isShopsite ? (
    <CheckboxPrimitive.Root
      ref={ref}
      className={joinClassNames(
        shopsiteBaseClasses,
        className,
        sharedClasses,
        shopsiteClasses
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="h-full w-full flex items-center justify-center text-current">
        <CheckIcon
          className={
            shopsiteVariant === "large" ? "h-4 w-4" : "h-[13px] w-[13px]"
          }
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ) : (
    <RadixCheckbox
      className={joinClassNames(
        sharedClasses,
        isShopsite ? shopsiteBaseClasses : "",
        isShopsite ? shopsiteClasses : whitelabelClasses
      )}
      {...props}
      ref={ref}
    />
  );
}
